module.exports = __webpack_public_path__ + "img/portrait-058.09a0f6e7.jpg";